import { render, staticRenderFns } from "./Body.vue?vue&type=template&id=fe698d36&scoped=true&"
import script from "./Body.vue?vue&type=script&lang=ts&"
export * from "./Body.vue?vue&type=script&lang=ts&"
import style0 from "./Body.vue?vue&type=style&index=0&id=fe698d36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe698d36",
  null
  
)

export default component.exports